import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { Trans } from "react-i18next";
import type { ObjPathProxy } from "ts-object-path";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { getResourcePath } from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	text: ObjPathProxy<MyPlannResourceDictionary, string>;
	values?: Record<string, string>;
	relaxed?: boolean;
	color?: string;
};

export const InspirationExampleText: FC<Props> = ({
	text,
	values,
	relaxed,
	color,
}) => {
	const theme = useTheme();

	return (
		<Typography
			variant="body2"
			color={color ?? theme.palette.grey[600]}
			relaxed={relaxed}
		>
			<Trans
				i18nKey={getResourcePath(text)}
				values={values}
				components={{
					b: <Typography component="span" variant="bodyStrong" tabular />,
					orange: (
						<Typography
							component="span"
							variant="bodyStrong"
							color={theme.palette.orange.main}
							tabular
						/>
					),
					blue: (
						<Typography
							component="span"
							variant="bodyStrong"
							color={theme.palette.blue.main}
							tabular
						/>
					),
				}}
			/>
		</Typography>
	);
};
